import { useQuery } from "@tanstack/react-query";
import { apiPost, apiGet } from "./axiosUtil"; // Adjust the path based on where `apiPost` is defined.
import API_URL from "../config/apiConfig";

export const fetchSubscribers = async (postData, role) => {
  try {
    const response = await apiPost(`${API_URL}/api/${role}/filters`, postData);
    return response.data; // Ensure this is valid
  } catch (error) {
    console.error("Error fetching Subscribers:", error);
    throw error; // Make sure error is correctly propagated
  }
};

export const fetchHosts = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/users/hosts`);
    // console.log("Hosts Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedule:", error);
    throw error; // Ensure proper error propagation
  }
};

export const fetchSubHosts = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/sub-hosts`);
    return {
      data: {
        content: response.data.data,
      },
    };
  } catch (error) {
    console.error("Error fetching Sub Host:", error);
    throw error;
  }
};

// export const fetchTransactions = async (user) => {
//   try {
//     const response = await apiGet(`${API_URL}/api/users/transactions`);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching transactions:", error);
//     throw error; // Ensure proper error propagation
//   }
// };

export const fetchTransactions = async (postData) => {
  try {
    const response = await apiPost(
      `${API_URL}/api/transactions/filters`,
      postData
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Transactions:", error);
    throw error;
  }
};

export const fetchMeetings = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/meetings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching meetings:", error);
    throw error;
  }
};

export const fetchSchedule = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/schedule`);
    return response.data;
  } catch (error) {
    console.error("Error fetching schedule:", error);
    throw error; // Ensure proper error propagation
  }
};

export const fetchRefunds = async (postData) => {
  try {
    const response = await apiPost(`${API_URL}/api/refunds/filter`, postData);
    return response.data;
  } catch (error) {
    console.error("Error fetching refunds:", error);
    throw error;
  }
};

export const fetchRefundHistory = async (parent) => {
  try {
    const response = await apiGet(
      `${API_URL}/api/refunds/parentHistory/${parent}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching refund history:", error);
    throw error;
  }
};

export const fetchAllZoomAccounts = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/zooms`);
    return {
      data: {
        content: response.data.data,
      },
    };
  } catch (error) {
    console.error("Error fetching refund history:", error);
    throw error;
  }
};

export const fetchAllHosts = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/hosts`);
    return {
      data: {
        content: response.data.data,
      },
    };
  } catch (error) {
    console.error("Error fetching refund history:", error);
    throw error;
  }
};

export const fetchManagers = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/managers`);
    return {
      data: {
        content: response.data.data,
      },
    };
  } catch (error) {
    console.error("Error fetching cutting meetings:", error);
    throw error;
  }
};

export const fetchCuttingMeetings = async (postData) => {
  try {
    const response = await apiPost(`${API_URL}/api/meetings/filters`, postData);
    return response.data;
  } catch (error) {
    console.error("Error fetching cutting meetings:", error);
    throw error;
  }
};

export const fetchSlots = async (postData) => {
  try {
    const response = await apiPost(`${API_URL}/api/slots/filters`, postData);
    return response.data;
  } catch (error) {
    console.error("Error fetching cutting meetings:", error);
    throw error;
  }
};

export const fetchHostSlots = async () => {
  try {
    const response = await apiGet(`${API_URL}/api/slots/host`);
    return {
      data: {
        content: response.data,
      },
    };
  } catch (error) {
    console.error("Error fetching cutting meetings:", error);
    throw error;
  }
};

// export const useFetchSubscribers = (postData, role, queryOptions = {}) => {
//   const fetchSubscribersCallback = () => fetchSubscribers(postData, role);
//   const queryResult = useQuery({
//     queryKey: [role, postData],
//     queryFn: fetchSubscribersCallback,
//     staleTime: 0,
//     cacheTime: 0,
//     refetchOnWindowFocus: true,
//     refetchOnReconnect: true,
//     retry: (failureCount, error) => {
//       if (!error.response) {
//         return failureCount < 3;
//       }
//       return false;
//     },
//     ...queryOptions,
//   });

//   return queryResult;
// };

// export const FetchScheduleFunc = (queryOptions = {}) => {
//   const queryResult = useQuery({
//     queryKey: ["schedule"],
//     queryFn: fetchSchedule,
//     staleTime: 30 * 60 * 1000,
//     cacheTime: 60 * 60 * 1000,
//     refetchOnWindowFocus: false,
//     refetchOnReconnect: false,
//     refetchOnMount: false, // 👈 Critical addition
//     refetchInterval: false,
//     retry: (failureCount, error) => {
//       if (!error?.response) return failureCount < 3;
//       // console.log("Schedule Error: ", error.response.data.data.errorMessage);
//       return false;
//     },
//     ...queryOptions, // Ensure parent options don't override critical settings
//   });

//   return queryResult;
// };

export const useFetchRefunds = (postData, queryOptions = {}) => {
  const queryResult = useQuery({
    queryKey: ["refunds", postData],
    queryFn: () => fetchRefunds(postData),
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false, // 👈 Critical addition
    refetchInterval: false,
    retry: (failureCount, error) => {
      if (!error?.response) return failureCount < 3;
      return false;
    },
    ...queryOptions, // Ensure parent options don't override critical settings
  });

  return queryResult;
};

export const useFetchRefundsHistory = (parent, queryOptions = {}) => {
  const queryResult = useQuery({
    queryKey: ["refunds", parent],
    queryFn: () => fetchRefundHistory(parent),
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false, // 👈 Critical addition
    refetchInterval: false,
    retry: (failureCount, error) => {
      if (!error?.response) return failureCount < 3;
      return false;
    },
    ...queryOptions, // Ensure parent options don't override critical settings
  });

  return queryResult;
};
